import {createTranslationMessages} from '@backstage/core-plugin-api/alpha';
import {kubernetesReactTranslationRef} from '@backstage/plugin-kubernetes-react/alpha';

export const kubernetesReactPtbr = createTranslationMessages({
    ref: kubernetesReactTranslationRef,
    messages: {
        "podDrawer.buttons.delete": "Excluir Pod"
    },
});

export default kubernetesReactPtbr;
